import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "clients-create-btn default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 text-decoration-none",
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": "#CreateClientModal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline me-2" }, "Criar novo cliente"),
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative fs-12" })
  ])
], -1)
const _hoisted_4 = {
  class: "d-flex align-items-center w-100 ms-lg-auto",
  style: {"max-width":"350px","position":"relative","z-index":"99"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Comece a digitar para buscar clientes.", -1)
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Telefone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Data Nasc. "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Editar "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Deletar ")
  ])
], -1)
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20" }
const _hoisted_26 = { class: "fs-14 text-muted mb-10 mb-sm-0" }
const _hoisted_27 = { "aria-label": "Paginação de clientes" }
const _hoisted_28 = { class: "pagination mb-0" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteClientModal = _resolveComponent("DeleteClientModal")!
  const _component_CreateClientModal = _resolveComponent("CreateClientModal")!
  const _component_UpdateClientModal = _resolveComponent("UpdateClientModal")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteClientModal),
    _createVNode(_component_CreateClientModal),
    _createVNode(_component_UpdateClientModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_multiselect, {
            ref: "clientSelect",
            modelValue: _ctx.selectedSearchClient,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSearchClient) = $event)),
            options: _ctx.getSalesContacts,
            searchable: true,
            loading: _ctx.isLoadingClients,
            "internal-search": false,
            "custom-label": _ctx.formatClientOption,
            taggable: false,
            label: "phone",
            "track-by": "id",
            "no-options-text": "Nenhum cliente encontrado.",
            "no-result-text": "Nenhum resultado para sua busca.",
            placeholder: "Buscar cliente...",
            onSearchChange: _ctx.debouncedFetchClients,
            onSelect: _ctx.onClientSelect,
            "close-on-select": true,
            id: "client_search",
            class: "w-100"
          }, {
            noOptions: _withCtx(() => [
              _hoisted_5
            ]),
            noResult: _withCtx(() => [
              _createTextVNode(" Nenhum cliente encontrado ")
            ]),
            _: 1
          }, 8, ["modelValue", "options", "loading", "custom-label", "onSearchChange", "onSelect"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getClientsList, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("th", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(value.name != '' && value.name != null  ? value.name : 'Sem nome'), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(value.email != '' && value.email != null  ? value.email : 'Sem email'), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("a", {
                      href: `https://wa.me/55${value.phone}`,
                      target: "_blank",
                      class: "text-decoration-none"
                    }, _toDisplayString(value.phone), 9, _hoisted_15)
                  ]),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(value.birth_date ? _ctx.formatBirthDate(value.birth_date) : ''), 1),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.openClientInfoTab(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#UpdateClientModal",
                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                      type: "button"
                    }, _hoisted_20, 8, _hoisted_18)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.setCurrentDeleteClient(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#DeleteClientModal",
                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                      type: "button"
                    }, _hoisted_24, 8, _hoisted_22)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, " Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.getClientsPagination.last_page || 1) + " — Total de " + _toDisplayString(_ctx.getClientsPagination.total || _ctx.getClientsList.length) + " clientes ", 1),
          _createElementVNode("nav", _hoisted_27, [
            _createElementVNode("ul", _hoisted_28, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "page-link",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1))),
                  disabled: _ctx.currentPage <= 1
                }, " Anterior ", 8, _hoisted_29)
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= _ctx.getClientsPagination.last_page }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "page-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1))),
                  disabled: _ctx.currentPage >= _ctx.getClientsPagination.last_page
                }, " Próxima ", 8, _hoisted_30)
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}